import { ComponentType, useContext } from 'react';

import { OfferModel } from '../../../model/OfferModel';
import { OfferState } from '../../../model/OfferState';
import { StateSwitchContext } from '../components/StateSwitchContextProvider';

interface ComponentProps {
    onConfirm: () => Promise<void>;
    onDismiss: () => void;
    isOpen: boolean;
    offer: OfferModel;
    isSubmitting: boolean;
}

interface IStateSwitchContext {
    changeState: (params: {
        destinationState: OfferState;
        offer: OfferModel;
        component?: ComponentType<ComponentProps>;
    }) => void;
}

export const useSwitchState = (): IStateSwitchContext => {
    return useContext(StateSwitchContext) as IStateSwitchContext;
};
